import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Href from 'components/ui/Href/Href'

import s from './ButtonBase.scss'


const ButtonBase = (props) => {
  const {
    // basic
    children, id, className, onClick, afterNode,

    // modifiers
    uppercase, fullWidth, fullWidthOnMobile, disabled, loading,

    // links
    to, toOLD, redirect,

    // misc
    size, color, weight, tag, type, dataAttributes, dataTestId,

    // ADA
    ariaLive,
    ariaLabel,
    ariaLabelledBy,
    ariaDescribedBy,
  } = props

  // Node -------------------------- /

  let node = tag

  if (to || toOLD || redirect) {
    node = Href
  }

  // Classes ----------------------- /

  const nodeClassName = cx(s.button, className, 'button', {
    [s[size || 'md']]: true,
    [s[color]]: color,
    [s[weight]]: weight,
    [s.fullWidth]: fullWidth,
    [s.fullWidthOnMobile]: fullWidthOnMobile,
    [s.uppercase]: uppercase,
    [s.disabled]: disabled,
    [s.notDisabled]: !disabled,
    [s.loading]: loading,
  })

  // Props -------------------------- /

  let nodeProps = {
    className: nodeClassName,
    id,
    type,
    disabled,
    onClick: (event) => {
      if (!disabled && !loading && typeof onClick === 'function') {
        onClick(event)
      }
    },
    'data-testid': dataTestId,
    'aria-live': ariaLive,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    'aria-describedby': ariaDescribedBy,
  }

  if (to || toOLD || redirect) {
    nodeProps = {
      ...nodeProps,
      to,
      toOLD,
      redirect,
    }
  }
  else {
    nodeProps.type = type
  }

  if (dataAttributes) {
    nodeProps = {
      ...nodeProps,
      ...dataAttributes,
    }
  }

  const nodeChildren = (
    <Fragment>
      {children}
      {afterNode}
    </Fragment>
  )

  return React.createElement(
    node,
    nodeProps,
    nodeChildren,
  )
}

ButtonBase.propTypes = {
  // basic
  children: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,

  // modifiers
  uppercase: PropTypes.bool,
  fullWidth: PropTypes.bool,
  fullWidthOnMobile: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,

  // links
  to: PropTypes.string,
  toOLD: PropTypes.string,
  redirect: PropTypes.string,

  // misc
  size: PropTypes.oneOf([ 'sm', 'md' ]),
  weight: PropTypes.oneOf(['normal', 'medium', 'semibold', 'bold']),
  color: PropTypes.oneOf([
    'brand', 'brandBorder', 'white', 'transparent', 'whiteActiveBrand',
    'brandTransparent', 'black', 'whiteColorBrand',
  ]),
  tag: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  dataTestId: PropTypes.string,

  // ADA
  ariaLabel: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
}

ButtonBase.defaultProps = {
  tag: 'button',
  color: 'transparent',
  weight: 'bold',
}


export default ButtonBase
